var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Cashing-Check--Streamline-Flex",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Cashing Check Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cashing-check--cashing-check-cheques-money-currency-payment-finance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.578 5.444H11.9c0.5 0 0.923 0.371 1.04 0.858 0.152 0.622 0.31 1.19 0.31 3.01 0 1.821 -0.158 2.39 -0.31 3.012 -0.117 0.486 -0.54 0.857 -1.04 0.857H2.1c-0.5 0 -0.923 -0.37 -1.037 -0.858C0.911 11.67 0.75 11.077 0.75 9.313c0 -1.765 0.161 -2.359 0.313 -3.01 0.114 -0.488 0.537 -0.859 1.037 -0.859h0.103",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.277 8.576 1.762 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.516 10.857 3.523 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.603 1.024 4.546 4.492l-0.419 1.97c-0.067 0.317 0.263 0.617 0.573 0.52l1.96 -0.617 3.157 -3.322c0.524 -0.552 0.433 -1.475 -0.202 -2.036 -0.62 -0.548 -1.52 -0.54 -2.012 0.017Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFeed);
export default __webpack_public_path__ + "static/media/active-feed.148065cd5faabe9917f4d05a1a068023.svg";
export { ForwardRef as ReactComponent };